import RegisterUser from "./RegisterUser";

export default RegisterUser;